module.exports = __webpack_public_path__ + "media/images/content_bg-172af032beced7855eb93ba38acdcc41.jpg";